// extracted by mini-css-extract-plugin
module.exports = {"presenterMenuOptionsHolder":"PresenterMenu_presenterMenuOptionsHolder__14TT1","scrollContainer":"PresenterMenu_scrollContainer__2YoSa"};